import camelcase from 'camelcase';

const exportEnv = {
  apiHost: 'https://my.smorder.at',
  imageUrl: 'https://smorder.blob.core.windows.net/images/', // 'https://smorder.blob.core.windows.net/images/',
  smorderEnv: null,
};

Object.keys(process.env).forEach((key) => {
  if (key.indexOf('REACT_APP_') === -1) {
    return;
  }
  const mappedKeyName = camelcase(key.replace('REACT_APP_', ''));
  exportEnv[mappedKeyName] = process.env[key];
});

export default exportEnv;
